import Icon from "@ant-design/icons";

const DepartmentSearchIconSVG = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.708 12.625C13.3664 12.625 13.083 12.3417 13.083 12V7.08333C13.083 6.96667 12.9914 6.875 12.8747 6.875H10.458C10.1163 6.875 9.83301 6.59167 9.83301 6.25C9.83301 5.90833 10.1163 5.625 10.458 5.625H12.8747C13.6747 5.625 14.333 6.28333 14.333 7.08333V12C14.333 12.3417 14.0497 12.625 13.708 12.625Z"
      fill="url(#paint0_linear_717_8108)"
    />
    <path
      d="M11.7085 8.12494C11.5668 8.12494 11.4252 8.07493 11.3085 7.98326L9.80851 6.73326C9.66685 6.6166 9.5835 6.44161 9.5835 6.24994C9.5835 6.05827 9.66685 5.89162 9.80851 5.76662L11.3085 4.51662C11.5752 4.29995 11.9668 4.33326 12.1918 4.59993C12.4168 4.8666 12.3752 5.25826 12.1085 5.48326L11.1835 6.24994L12.1085 7.01662C12.3752 7.24162 12.4085 7.63328 12.1918 7.89995C12.0668 8.04995 11.8835 8.12494 11.7085 8.12494Z"
      fill="url(#paint1_linear_717_8108)"
    />
    <path
      d="M6.2915 12.625C5.94984 12.625 5.6665 12.3417 5.6665 12V8.5C5.6665 8.15833 5.94984 7.875 6.2915 7.875C6.63317 7.875 6.9165 8.15833 6.9165 8.5V12C6.9165 12.3417 6.63317 12.625 6.2915 12.625Z"
      fill="url(#paint2_linear_717_8108)"
    />
    <path
      d="M6.41651 8.875C5.17485 8.875 4.1665 7.86668 4.1665 6.62501C4.1665 5.38334 5.17485 4.375 6.41651 4.375C7.65818 4.375 8.66652 5.38334 8.66652 6.62501C8.66652 7.86668 7.65818 8.875 6.41651 8.875ZM6.41651 5.625C5.86651 5.625 5.4165 6.07501 5.4165 6.62501C5.4165 7.17501 5.86651 7.62499 6.41651 7.62499C6.96651 7.62499 7.41652 7.17501 7.41652 6.62501C7.41652 6.07501 6.96651 5.625 6.41651 5.625Z"
      fill="url(#paint3_linear_717_8108)"
    />
    <path
      d="M6.29149 15.625C5.11649 15.625 4.1665 14.675 4.1665 13.5C4.1665 12.325 5.11649 11.375 6.29149 11.375C7.46649 11.375 8.41648 12.325 8.41648 13.5C8.41648 14.675 7.46649 15.625 6.29149 15.625ZM6.29149 12.625C5.80816 12.625 5.4165 13.0167 5.4165 13.5C5.4165 13.9833 5.80816 14.375 6.29149 14.375C6.77483 14.375 7.16648 13.9833 7.16648 13.5C7.16648 13.0167 6.77483 12.625 6.29149 12.625Z"
      fill="url(#paint4_linear_717_8108)"
    />
    <path
      d="M13.708 15.625C12.533 15.625 11.583 14.675 11.583 13.5C11.583 12.325 12.533 11.375 13.708 11.375C14.883 11.375 15.833 12.325 15.833 13.5C15.833 14.675 14.883 15.625 13.708 15.625ZM13.708 12.625C13.2247 12.625 12.833 13.0167 12.833 13.5C12.833 13.9833 13.2247 14.375 13.708 14.375C14.1913 14.375 14.583 13.9833 14.583 13.5C14.583 13.0167 14.1913 12.625 13.708 12.625Z"
      fill="url(#paint5_linear_717_8108)"
    />
    <path
      d="M12.4998 18.9583H7.49984C2.97484 18.9583 1.0415 17.025 1.0415 12.5V7.49996C1.0415 2.97496 2.97484 1.04163 7.49984 1.04163H12.4998C17.0248 1.04163 18.9582 2.97496 18.9582 7.49996V12.5C18.9582 17.025 17.0248 18.9583 12.4998 18.9583ZM7.49984 2.29163C3.65817 2.29163 2.2915 3.65829 2.2915 7.49996V12.5C2.2915 16.3416 3.65817 17.7083 7.49984 17.7083H12.4998C16.3415 17.7083 17.7082 16.3416 17.7082 12.5V7.49996C17.7082 3.65829 16.3415 2.29163 12.4998 2.29163H7.49984Z"
      fill="url(#paint6_linear_717_8108)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_717_8108"
        x1="9.83301"
        y1="9.125"
        x2="14.333"
        y2="9.125"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_717_8108"
        x1="9.5835"
        y1="6.24966"
        x2="12.3375"
        y2="6.24966"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_717_8108"
        x1="5.6665"
        y1="10.25"
        x2="6.9165"
        y2="10.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_717_8108"
        x1="4.1665"
        y1="6.625"
        x2="8.66652"
        y2="6.625"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_717_8108"
        x1="4.1665"
        y1="13.5"
        x2="8.41648"
        y2="13.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_717_8108"
        x1="11.583"
        y1="13.5"
        x2="15.833"
        y2="13.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_717_8108"
        x1="1.0415"
        y1="9.99996"
        x2="18.9582"
        y2="9.99996"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F16444" />
        <stop offset="1" stop-color="#F47E63" />
      </linearGradient>
    </defs>
  </svg>
);
const DepartmentSearchIcon = (props) => (
  <Icon component={() => DepartmentSearchIconSVG(props)} {...props} />
);

export default DepartmentSearchIcon;
